import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, NgZone } from '@angular/core';
import { ApiService } from '../../service/api.service.js';
import { AuthenticationService } from '../../service/authentication.service.js';
import { UtilService } from '../../service/util.service.js';
import { Constants } from '../../constants/constants.js';
import { DeviceService } from '../../service/device.service.js';
import { isNullOrUndefined } from 'util';
import { EnrollmentConstants } from '../../constants/enrollment-constants.js';
import { ToastService } from '../../service/toast.service.js';

@Component({
  selector: 'app-view-device-detail',
  templateUrl: './view-device-detail.component.html',
  styleUrls: ['./view-device-detail.component.scss']
})
export class ViewDeviceDetailComponent implements OnInit {
  @Input() deviceData;

  // @Input() selectedVin;
  // selectedVehicle;
  @Input() showAccount: boolean = false;
  //@Input() isShowEditbtn = true;
  //@Output() submitEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();
  location: any = {};
  account: any = {};
  servicePackageList: any = [];

  // deviceDates: Array<any> = []
  sortType = ['DESCENDING', 'ASCENDING'];

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private zone: NgZone, private deviceService: DeviceService,
    private toastService: ToastService) { }
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.init();
  }

  init() {
    /* if (this.deviceData.vin) {
      this.getVehicleDetail();
    } */
    //this.servicePackageData = [];
    this.account = this.authService.accountData;
    // this.initDeviceDates();
    console.log("Device data : ", this.deviceData);
    console.log("Account Data:", this.account);
    // this.getDevicesLocation(this.account.id, this.deviceData.vin)
    //this.getDevicesServicePackageLocationInfo(this.account.id, this.deviceData.vin);
  }

  closeClicked() {
    this.closeEmitter.emit(JSON.parse(JSON.stringify(this.deviceData)));
  }

  getDeviceLogo(device): string {
    return this.deviceService.getDeviceLogo(device);
  }

  /* initDeviceDates() {
    var deviceStateDateValue = [ "orderedDate", "deliveryDate", "enrolledDate", "unenrolledDate"];
    var deviceStatusDateKey = [EnrollmentConstants.ORDERED_DATE, EnrollmentConstants.DELIVERY_DATE, EnrollmentConstants.ENROLLMENT_DATE, EnrollmentConstants.UNENROLLMENT_DATE];

    this.deviceDates.push(this.getDeviceHistoryObject(deviceStatusDateKey[0], this.deviceData[deviceStateDateValue[0]]));

    if (this.deviceData.status == EnrollmentConstants.DELIVERED || this.deviceData.status == EnrollmentConstants.INACTIVE || this.deviceData.status == EnrollmentConstants.ASSIGNED) {
      this.deviceDates.push(this.getDeviceHistoryObject(deviceStatusDateKey[1], this.deviceData[deviceStateDateValue[1]]));

      if (this.deviceData.enrollmentStatus == EnrollmentConstants.UNENROLLED) {
        this.deviceDates.push(this.getDeviceHistoryObject(deviceStatusDateKey[2], this.deviceData[deviceStateDateValue[2]]));
        this.deviceDates.push(this.getDeviceHistoryObject(deviceStatusDateKey[3], this.deviceData[deviceStateDateValue[3]]));
      }
    }
    else if (this.deviceData.status == EnrollmentConstants.ACTIVE) {
      this.deviceDates.push(this.getDeviceHistoryObject(deviceStatusDateKey[1], this.deviceData[deviceStateDateValue[1]]));
      this.deviceDates.push(this.getDeviceHistoryObject(deviceStatusDateKey[2], this.deviceData[deviceStateDateValue[2]]));
    }
  } */


  /* initVehicleDates() {
    var vehicleStateDateValue = ["orderedDate", "deliveryDate", "enrolledDate", "unenrolledDate"];
    var vehicleStatusDateKey = [EnrollmentConstants.ORDERED_DATE, EnrollmentConstants.DELIVERY_DATE, EnrollmentConstants.ENROLLMENT_DATE, EnrollmentConstants.UNENROLLMENT_DATE];

    this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[0], this.vehicleData[vehicleStateDateValue[0]]));

    if (this.vehicleData.status == EnrollmentConstants.DELIVERED || this.vehicleData.status == EnrollmentConstants.INACTIVE || this.vehicleData.status == EnrollmentConstants.ASSIGNED) {
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[1], this.vehicleData[vehicleStateDateValue[1]]));

      if (this.vehicleData.enrollmentStatus == EnrollmentConstants.UNENROLLED) {
        this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[2], this.vehicleData[vehicleStateDateValue[2]]));
        this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[3], this.vehicleData[vehicleStateDateValue[3]]));
      }
    }
    else if (this.vehicleData.status == EnrollmentConstants.ACTIVE) {
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[1], this.vehicleData[vehicleStateDateValue[1]]));
      this.vehicleDates.push(this.getVehicleHistoryObject(vehicleStatusDateKey[2], this.vehicleData[vehicleStateDateValue[2]]));
    }
  } */

  /* getDeviceHistoryObject(key: string, value: any) {
    var deviceHistory = { 'key': key, 'value': '' };
    if (!isNullOrUndefined(value)) {
      deviceHistory.value = value;
    }
    return deviceHistory;
  } */

 /*  getSortedDateList(numberList, sortType: string) {
    let that = this;
    let sortedList = numberList.sort(function (a, b) {
      if (sortType == that.sortType[1]) {
        return <any>new Date(a.value) - <any>new Date(b.value);
      } else {
        return <any>new Date(b.value) - <any>new Date(a.value);
      }
    });
    return sortedList;
  } */

  // getVehicleDetail() {
  //   this.utilService.showSpinner();
  //   this.apiService.getVehicleDetails(this.deviceData.vin).then((data) => {
  //     this.utilService.hideSpinner();
  //     console.log("Get vehicle detail from api : ", data);
  //     this.processVehicleDetails(data);
  //     // this.isDeviceUpdateClicked = false;
  //     // this.initTcuDevices(data.devices);
  //     // if (data.devices) {
  //     //   this.tcuDevices = data.devices;
  //     // }
  //   }).catch((error) => {
  //     console.log("err : ", error);
  //     if (error.status == Constants.HTTP_UNAUTHORISED) {
  //       this.authService.refreshToken().then(() => {
  //         this.utilService.hideSpinner();
  //         console.log("refresh token api executed");
  //         this.getVehicleDetail();
  //       });
  //     }
  //     else {
  //       this.utilService.hideSpinner();
  //       if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
  //       else this.toastService.showError(Constants.UNKNOWN_ERROR);
  //     }
  //   });
  // }

  // processVehicleDetails(data: any) {
  //   this.selectedVehicle = data;
  // }
  processLinkToVehicleDeviceResponse(deviceData) {
    
    this.deviceData = deviceData;
  }
  
}